<ion-app id="app" data-testid="app">
  @if (loading) {
    <div class="loader" data-testid="loader">
      <ion-spinner color="light"></ion-spinner>
    </div>
  }
  <ion-router-outlet></ion-router-outlet>
</ion-app>
